import { ethWalletFormat } from "../../data/Utils";

export default function EthWallet(props: {isSeller: boolean, currency: string, addr: string}) {
    return (
        <div className='flexRow gap5 justifyStart'>
            <img alt='' height='22px' width='22px' style={{marginTop: '4px'}} title={props.isSeller ? 'The seller received money!' : 'The buyer received a jpeg :)'} src={props.isSeller ? 'bling-' + props.currency.toLowerCase() + '-32.png' : 'frame-32.png'}/>
            <div>{ethWalletFormat(props.addr)}</div>
            <img alt='' title='Copy to clipboard' src='icon-copy.svg' style={{marginTop: '4px'}} onClick={() => navigator.clipboard.writeText(props.addr)}/>
        </div>
    );
}